<template>
	<div class="l-r"  v-loading="loading"
		element-loading-text="拼命加载中">
		<div class="knowledge-warp-l-nav">

			<div class="knowledge-warp-l-nav-type">
				<el-radio-group v-model="itemBankType" @change="getTestList()">
					<el-radio label="default">公共题库</el-radio>
					<el-radio label="private">私人题库</el-radio>
				</el-radio-group>
			</div>
			
			<!-- <label for="switch-l" class="switch-l">
				<input id="switch-l" type="checkbox" name="nav" v-model="isscrollbar">
			</label> -->
			<input type="checkbox" name="nav" v-model="isscrollbar">
				
			<ul class="question-bank-h-type">

				<li class="question-bank-h-list">
					<span>题型:</span>
					<div>
						<template>
						  <el-radio-group v-model="question.type" @change="getTestList()">
						  	<template v-for="item of questionTypeList">
						  		<el-radio :label="item.id">{{item.name}}</el-radio>
						  	</template>
						  </el-radio-group>
						</template>
					</div>
				</li>

				<li class="question-bank-h-list">
					<span>难度:</span>
					<div>
						<template>
						  <el-radio-group v-model="question.difficulty" @change="getTestList()">
						    <el-radio :label="0">全部</el-radio>
						    <el-radio :label="11">容易</el-radio>
						    <el-radio :label="12">普通</el-radio>
						    <el-radio :label="13">困难</el-radio>
						  </el-radio-group>
						</template>
					</div>
				</li>

				<li class="question-bank-h-list">
					<span>题目范围:</span>
					<div>
						<template>
						  <el-select clearable v-model="question.grade" placeholder="请选择年级" @change="setRange($event, 'grade')">
						    <el-option
						      v-for="(item, index) in gradeLsit"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<template>
						  <el-select clearable v-model="question.subject" placeholder="请选择科目" @change="setRange($event, 'subject')">
						    <el-option
						      v-for="(item, index) in subjectLsit"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<template>
						  <el-select clearable v-model="question.edition" placeholder="请选择版本" @change="setRange($event, 'edition')">
						    <el-option
						      v-for="(item, index) in editionList"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<template>
						  <el-select clearable v-model="question.material" placeholder="请选择教材" @change="setMaterial">
						    <el-option
						      v-for="(item, index) in materialList"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<el-button type="primary" @click="getTestList()">筛选</el-button>
					</div>
				</li>

				<li class="question-bank-h-list">
					<span>{{optionVal == 1 ? '章节' : '知识点'}}:</span>
					<div >

						
						<template v-if="optionVal == 1">
								<el-cascader :options="chapterList"  placeholder= '选择章节'
								 filterable clearable
								 v-model="question.chapter"
								@change="chapterChange">
								</el-cascader>
						</template>
						<template v-else>
							<el-cascader :options="knowledgeList"  placeholder= '选择知识点'
							filterable clearable
							 v-model="question.knowled"
							@change="knowledgeChange">
							</el-cascader>
						</template>

						<el-popover placement="top"  width="200" v-model="visibleType" v-if="0">
							<div class="bank-option">
								<el-radio-group v-model="optionVal" size="small" @change="getOption">
									<el-radio label="1" border>选择知识点</el-radio>
									<el-radio label="2" border>选择章节</el-radio>
								</el-radio-group>
							</div>
							<el-button slot="reference" type="text">选择形式	</el-button>
						</el-popover>
						
						
					</div>
				</li>

			</ul>


			<div class="question-bank-wp-r-h">
				<div>
					<el-input
						placeholder="搜索试题"
						suffix-icon="el-icon-search"
						v-model="question.keyword" @change="getTestList()">
					</el-input>


					<el-radio-group v-model="question.order" @change="getTestList()">
						<el-radio label="time">最新<i class="el-icon-sort-down"></i></el-radio>
						<el-radio label="fav">热门<i class="el-icon-sort-down"></i></el-radio>
					</el-radio-group>

				</div>

			</div>
			
		</div>

		<el-scrollbar :class="{ 'knowledge-scrollbar': isscrollbar}">
		
			<ul class="preview-conten-subject">

				<template v-for="(item, index) of testList">
					<transition name="el-zoom-in-top">
					<li class="preview-conten-subject-c" :key="index">
						<template>
							<div  v-if="item.pattern === 1" class="preview-conten-subject-t">
								<i>{{index+1}}. </i>
								<span v-html="item.content"></span>
								<strong v-if="item.score">({{item.score}}分)</strong>
							</div>
							<div  v-if="item.pattern === 2" class="preview-conten-subject-t">
								<i>{{index+1}}. </i>
								<span v-html="item.content"></span>
								<strong v-if="item.score">({{item.score}}分)</strong>
							</div>
						</template>

						<ul class="preview-topic" v-if="item.option">
							<template v-for="(option,index2) of item.option" >

								<li class="preview-subject-title preview-false option-pattern" v-if="item.qt_id === 9"  :key="index2">
									<template >
										<el-checkbox disabled :label="option.name">{{option.name}}</el-checkbox>
									</template>
								</li>

								<template v-else>
									<li class="preview-subject-title preview-false" v-if="item.pattern === 1" :key="index2">
										<template>
											<el-checkbox disabled :label="option.name"></el-checkbox>
											<div  v-html="option.value"></div>
										</template>
									</li>

									<li class="preview-subject-title preview-false option-pattern" v-if="item.pattern === 2"  :key="index2">
										<template >
											<el-checkbox disabled :label="option.name"></el-checkbox>
											<!-- <div  v-html="option.value"></div> -->
										</template>
									</li>
								</template>
								
							</template>
						</ul>

						<el-collapse accordion class="preview-answer">
							<el-collapse-item>
								<template slot="title">
									<div class="preview-accordion-title">
										<span>题型：{{item.question_type}}</span>
										<span>难度： {{item.difficulty}}</span>
										<span v-if="item.keynote == 1">重点程度： 低</span>
										<span v-if="item.keynote == 2">重点程度： 中</span>
										<span v-if="item.keynote == 3">重点程度： 高</span>
									</div>
									<div class="accordion-operate" @click.stop="">
										<transition name="el-fade-in-linear">
											<a class="accordion-" v-show="itemBankType == 'default' "  @click.stop="operationTest($event, 1, item)">添加到我的题库</a>
										</transition>
											<el-button type="primary" v-show="item.exist == 0" v-preventReClick  @click.stop="operationTest($event, 2, item, index)"><i class="el-icon-plus"></i>加入试卷</el-button>

											<el-button type="danger" v-show="item.exist == 1"  v-preventReClick  @click.stop="operationTest($event, 3, item, index)">移除试题</el-button>
										
											<!-- <el-button type="success">已在试卷列表</el-button> -->
									
										
									</div>
								</template>
								<div class="preview-accordion-answer" v-if="item.qt_id == 1 || item.qt_id == 2 || item.qt_id == 9">

									<span>正确答案： </span>
									<template v-if="item.qt_id == 9">
										<div v-if="item.answer"><i>{{item.answer[0]}}</i></div>
									</template>
									<template v-else-if="item.qt_id == 1 || item.qt_id == 2">
										<div><i v-for="answer of item.answer">{{answer}}</i></div>
									</template>
									
								</div>
								<div class="preview-accordion-answer">
									<span>统计： </span>
									<div>本题共被作答 {{item.question_info.answer_count}} 次，正确率为 {{item.question_info.true_probability}}%</div>
								</div>
								<div class="preview-accordion-answer">
									<span>解析： </span>
									<template v-if="item.pattern == 1">
										<div v-html="item.resolve"></div>
									</template>
									<template v-if="item.pattern == 2">
										<div>
											<img :src="BASE_URL + item.resolve_path">
										</div>
									</template>
								</div>
							</el-collapse-item>
						</el-collapse>
					</li>
					</transition>
				</template>

			</ul>
		</el-scrollbar>

		<div class="dependent" v-if="placeholder">
			<i class="ipng image_state01"></i>
			<p>还没发现任何相关的内容哦~</p>
		</div>

		<el-dialog  
		  title="查看图片" width="80%"
		  :visible.sync="imgVisible"
		  custom-class="imgVisible" top="5vh">
			  <el-carousel  :autoplay="false" :loop="false">
			  	<el-carousel-item v-for="item of imgArray " :key="item">
			  		<img :src="item">
			  	</el-carousel-item>
			  </el-carousel>
		</el-dialog>
	</div>
</template>

<script>
	import bus  from  './../base/eventBus.js'
	export default{
		data(){
			return {
				optionVal: null,
				visibleType: false,
				isscrollbar: false,
				itemBankType: 'default', /*试题 公开 || 私有*/
				question: {
					knowledge: '',
					difficulty: 0,  /*难度*/
					type: 0, 		/*试题类型*/
					grade: '', 		/*年级id*/
					subject: '',    /*科目id*/
					edition: '', 	/*版本id*/
					material: '',	/*教材*/
					order: 'time',			/*列表排序*/
					keyword: '', 			/*搜索关键字*/
					page: 1,
					size: 0,
					total: 0,
					knowled: '',
					chapter: ''
				},
				testList: [],
				gradeLsit: [], 		/*年级列表*/
				subjectLsit: [], 	/*科目列表*/
				editionList: [], 	/*版本列表*/
				materialList: [],	/*教材*/
				questionTypeList: [], /*题型*/
				knowledgeList: [],
				chapterList: [],
				questionArray: [],
				arrayID: [],
				loading: true,
				placeholder: false,

				imgVisible: false,
				imgArray: [],
				imgIndex: 0
				
			}
		},
		computed: {
			
		},
		watch: {
			'$store.state.delQuestion': {
				handler(to, from){

					if (to !== 0) {
						this.arrayID.splice(this.arrayID.indexOf(to), 1)
						this.$store.commit('SET_DELQUESTION', 0)
					}
					
				},
				immediate: true
			}
		},
		created(){
			
			this.getGrade()
			this.getQuestionType()
			this.getTestList()
			
			bus.$on("delQuestion", (questionTyle) => {
				this.getTestList()
			})
		},
		mounted(){
			this.$nextTick(()=>{
				document.querySelector('.knowledge-warp-l').addEventListener('click',  (e)=> {
		
					let [targetSrc ,imgs, srcArr, currentIdx] = ['', '', '', '']
					if (e.target.nodeName === 'IMG') {

						this.imgVisible = true
						targetSrc = e.target.src;
						imgs = [...e.target.parentNode.children];
						srcArr = imgs.map(item=>item.currentSrc);
						currentIdx = srcArr.indexOf(targetSrc);
						
						this.imgArray = srcArr
						this.imgIndex = currentIdx
					}
				
				}, false)
			});
		},
		methods: {
			changQuestionid(){
				return this.arrayID
			},
			/*选择知识点 || 章节数据加载*/
			getOption(type){

				this.question.chapter =  '';	/*章节*/
				this.question.knowled =  '';	/*知识点*/

			},
			/**
			 * 请求试卷列表
			 * @DateTime 2019-07-22T13:47:02+0800
			 */
			getTestList(){
				let success = ( res=>{
					this.testList = res.data.data;
					this.question.page = parseInt(res.data.page_index);
					this.question.total  = parseInt(res.data.data_sum);

					this.testList.map(item => item.score = 5)

					setTimeout(()=>{
						let manualObj = JSON.parse(sessionStorage.getItem('manualObj'));
						this.optionVal = manualObj.authType
					}, 500);

					this.$nextTick(()=>{
						
						//改变试题 img 的 url
						let imgArr = document.querySelectorAll('.preview-conten-subject-c img')
						let baseUrl = sessionStorage.getItem('host_addr');
						for (var i = 0; i < imgArr.length; i++) {
							let _temp = imgArr[i].src
							imgArr[i].src = _temp.replace(location.protocol+'//'+location.host, baseUrl);
						}
					});
					this.loading = false;
					this.testList.length != 0 ? this.placeholder = false : this.placeholder = true;
				});

				/*1手动录入 2图片录入*/
				let [listid, knowid] = ['', ''];
				if (this.question.chapter.length != 0) {
					listid = deep_clone(this.question.chapter).pop()
				}
				if (this.question.knowled.length != 0) {
					knowid = deep_clone(this.question.knowled).pop()
				}

				let params = {
					user_id: this.$g.user_id,
					grade_id: this.question.grade,
					subject_id: this.question.subject,
					version_id: this.question.edition,
					masterial_id: this.question.material,
					keyword: this.question.keyword,
					order: this.question.order,
					difficulty_id: this.question.difficulty,
					type_id: this.question.type,
					list_id: listid,/*章节id*/
					know_id: knowid,/*知识点id*/
					type: this.itemBankType,
					page_index: 0,
					page_size: 0,
				};

				this.$ajax({
					url: 'api/newtest/test_question_list',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求题型数据
			 * @DateTime 2019-07-25T14:04:59+0800
			 * @return   {[type]}                 [description]
			 */
			getQuestionType(){

				let success = (res=>{
					this.questionTypeList = res.data;
					if (this.questionTypeList.length > 0) {
						this.questionTypeList.unshift({id: 0, name: '全部'})
					}
				});

				let params = {status: 1};

				this.$ajax({
					url: 'api/newtest/get_question_type',
					method: 'get',
					params: params,
					func: { success: success}
				})
			},
			/**
			 * 请求年级列表数据
			 * @DateTime 2019-07-22T14:45:06+0800
			 */
			getGrade(){
				let success = (res=>{
					this.gradeLsit = res.data;
				});

				let params = {
					level:3,
					// pid:0,
					direction:'balance',
				};

				this.$ajax({
					url: 'api/org/org',
					method: 'get',
					params: params,
					func: { success: success}
				})
			},
			/**
			 * 请求科目数据
			 * @DateTime 2019-07-22T14:53:30+0800
			 */
			getSubject(){
				let success = (res=>{
					this.subjectLsit = res.data
				});

				let params = {
					type:2,
					org_id: this.question.grade,
					status:1,
				};

				this.$ajax({
					url: 'api/cate/subject',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求科目版本
			 * @DateTime 2019-07-22T15:30:28+0800
			 */
			getEdition(){
				let success = (res=>{
					this.editionList = res.data;
				});

				let params = {
					type:2,
					org_id:this.question.grade,
					sub_id:this.question.subject,
					status:1
				};

				this.$ajax({
					url: 'api/cate/version',
					methosd: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求教材列表数据
			 * @DateTime 2019-07-22T15:39:04+0800
			 * @return   {[type]}                 [description]
			 */
			getMaterial(){
				let success = (res=>{
					this.materialList = res.data;

				});

				let params = {
					org_id:this.question.grade,
					sub_id:this.question.subject,
					ver_id:this.question.edition,
					status:1
				};

				this.$ajax({
					url: 'api/cate/material',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求章节数据
			 * @DateTime 2019-07-23T14:04:49+0800
			 * @return   {[type]}                 [description]
			 */
			getChapter(){
				if (this.question.material === '') {return};

				let success = (res=>{
					this.chapterList  = []

					res.data.forEach((item, index)=>{
						this.chapterList.push({
							value: item.id,
							label: item.name,
							children: []
						})

						if (item.children.length != 0) {

							item.children.forEach(child=>{
								this.chapterList[index].children.push({
									value: child.id,
									label: child.name
								})
							})
						}else{
							this.$set(this.chapterList[index], 'disabled', true)
						}


					})
				});

				let params = {}

				 params = {
					material_id: this.question.material,
					type: 1
				};

				let fail = (res=>{
					this.$message.error({
						duration: 8000,
						message: res.msg
					})
				})

				this.$ajax({
					url: 'api/newtest/get_list_know_by_material',
					method: 'get',
					params: params,
					func: {success: success, fail: fail}
				})
			},
			/**
			 * 获取章节选择的id
			 * @return {[type]} [description]
			 */
			chapterChange(val) {

			  this.question.chapter = val
			  this.getTestList()
			},
			/**
			 * 请求章知识点数据
			 * @DateTime 2019-07-23T14:04:49+0800
			 * @return   {[type]}                 [description]
			 */
			getKnowledge(){
				// if (this.question.material === '') {return};

				let success = (res=>{
					this.knowledgeList  = []

					res.data.forEach((item, index)=>{
						this.knowledgeList.push({
							value: item.id,
							label: item.name,
							children: []
						})

						if (item.children.length != 0) {

							item.children.forEach(child=>{
								this.knowledgeList[index].children.push({
									value: child.id,
									label: child.name
								})
							})
						}else{
							this.$set(this.knowledgeList[index], 'disabled', true)
						}


					})
				});

				let params = {}

				 params = {
					material_id: this.question.material,
					type: 2
				};

				let fail = (res=>{
					this.$message.error({
						duration: 8000,
						message: res.msg
					})
				})

				this.$ajax({
					url: 'api/newtest/get_list_know_by_material',
					method: 'get',
					params: params,
					func: {success: success, fail: fail}
				})
			},
			/**
			 * 获取知识点选择的id
			 * @DateTime 2019-09-04T11:42:45+0800
			 * @param    {[type]}                 val [description]
			 * @return   {[type]}                     [description]
			 */
			knowledgeChange(val){
				this.question.knowled = val
				this.getTestList()
			},

			/**
			 * 判断教材是否为空，在不为空时，根据id筛选相关的试题
			 * @DateTime 2019-07-24T09:27:20+0800
			 * @param    {[Strong]}   val 教材id
			 */
			setMaterial(val){

				if (val != '') {
					// console.log(val, 1)
					this.getChapter()
					this.getKnowledge()
				}else{
									// console.log(val, 2)
					this.question.material = ''
					this.question.chapter =  '';	/*章节*/
					this.question.knowled =  '';	/*知识点*/

					this.chapterList =  [] 	/* 章节列表*/
					this.knowledgeList = []	/*知识点*/
				}

			},
			/**
			 * 改变题目范围
			 * @param {String} val 选择的id
			 * @param {String} type
			 * 根据改变当前参数重置相关数据
			 */
			setRange(val,type){
				switch( type ){
					case 'grade': /*年级*/
					
						if (this.question.grade == '') {
							this.question.subject = '';
							this.question.edition = '';
							this.question.material = '';

							this.subjectLsit = [];
							this.editionList = [];
							this.materialList = [];
							this.chapterList = []

							this.question.chapter =  '';	/*章节*/
							this.question.knowled =  '';	/*知识点*/

							this.chapterList =  [] 	/* 章节列表*/
							this.knowledgeList = []	/*知识点*/

							this.getTestList()
						}else{
							this.question.subject = '';
							this.question.edition = '';
							this.question.material = '';

							this.subjectLsit = [];
							this.editionList = [];
							this.materialList = [];

							this.question.chapter =  '';	/*章节*/
							this.question.knowled =  '';	/*知识点*/

							this.chapterList =  [] 	/* 章节列表*/
							this.knowledgeList = []	/*知识点*/

							this.getSubject();
						}
					break;
					case 'subject': /*科目*/
						this.question.edition = '';
						this.question.material = '';

						this.editionList = [];
						this.materialList = [];

						this.question.chapter =  '';	/*章节*/
						this.question.knowled =  '';	/*知识点*/

						this.chapterList =  [] 	/* 章节列表*/
						this.knowledgeList = []	/*知识点*/

						this.getEdition();
					break;
					case 'edition': /*版本*/
						this.question.material = '';
						this.materialList = [];
						this.question.chapter =  '';	/*章节*/
						this.question.knowled =  '';	/*知识点*/

						this.chapterList =  [] 	/* 章节列表*/
						this.knowledgeList = []	/*知识点*/
						this.getMaterial();
					break;
				}
			},
			/**
			 * type 参数对应不同的函数，
			 *
			 * 1.添加到我的题库
			 * 2.加入试卷
			 */
			operationTest(e, type, obj, index){

				e.preventDefault();
				switch(type){
					case 1:
						this.$confirm('是否添加到我的题库？', '提示', {
							cancelButtonText: '取消',
							confirmButtonText: '确定',
							type: 'warning',
							customClass: "test-message"
						}).then(() => {
							let success = (res=>{
								this.$message.success(res.msg)
							});

							let params = {id: obj.id};

							this.$ajax.post('api/newtest/fav_test_question', params, {func: {success: success}})
						}).catch(() => {});
					break;
					case 2:
						// this.questionArray = [];

						/*判断用户加入的试题是否重复添*/
						if (this.arrayID.includes(this.testList[index].id)) {
							return this.$message.warning('已重复添加该试题...')
							
						}else{
							// this.$message.success('添加成功');
							// this.testList[index].exist = 1;
						}
						// let id = deep_clone(this.testList[index].id)
						// /*用户加入的试题的数组*/
						 this.arrayID.push(this.testList[index].id)
						 this.arrayID = [...new Set(this.arrayID)]

						 	// console.log(this.$store.state.delQuestion, this.arrayID, 1)

						//  /*根据加入试题的数组的id组装杨工新的试卷数组 */
						//  for (var i = 0; i < this.testList.length; i++) {
						//  	if (this.arrayID.includes(this.testList[i].id)) {
						//  		this.questionArray.push(this.testList[i])
						//  	}
						//  }
						 let success = (res=>{
						 	this.$message.success(res.msg)
						 	this.$store.commit('SET_QUESTIONCHANGE', new Date())
						 })
						  let params = '';

						  if (this.$route.query.id) {
						  	params = {
						  		testid: this.$route.query.id,
						  		question_id: obj.id
						  	}
						  }else{
						  	params  = {
						  		testid: this.$route.query.edit,
						  		question_id: obj.id
						  	}
						  }
						
						 this.$ajax.post('api/test/bind_one_question_to_test', params, {func:{success: success}})

					
						
						 // bus.$emit('testChange', this.questionArray);

					break;
					case 3:
						this.testList[index].exist = 0;
						this.arrayID.splice(this.arrayID.indexOf(this.testList[index].id), 1)
						this.questionArray.splice(this.questionArray.indexOf(this.testList[index]), 1)
						this.$store.commit('SET_QUESTIONCHANGE', obj.id)
						// console.log(val);
						bus.$emit('testChange', this.questionArray);
						this.$message.warning('删除成功');

					break;

				}
			},
		}
	}
</script>